module["exports"] = [
  "######"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ru/address/postcode.js
 ** module id = 976
 ** module chunks = 0
 **/